import { EyeOutlined } from '@ant-design/icons';
import { Add, DeleteOutlineOutlined, Edit, Search, Tune } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Autocomplete, Checkbox, ClickAwayListener, FormControlLabel, FormGroup, IconButton, Paper, Popper, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import noData from "../../assets/svg/Emptyfile1.svg";
import DeleteModal from '../../components/Modals/DeleteModal';
import { newHost } from '../Categories/CategoryProfile';
import "./Notification.css";

const CriteriaBlock = ({
  index,
  control,
  register,
  remove,
  criteriaAvailableFields,
  criteriaOperators,
  isEdit
}) => {
  const {
    fields: valueFields,
    append: appendValue,
    remove: removeValue,
  } = useFieldArray({
    control,
    name: `criteria.${index}.value`,
  });


useEffect(() => {
  if (!isEdit && valueFields.length == 0) {
    appendValue("");
  }
}, [isEdit, valueFields, appendValue]);


  return (
    <div className="border p-3 mb-3 rounded-2">
      <div className="d-flex justify-content-between align-items-center ">
        <h6 className="fw-bold font-size-responsive m-0">Criterion {index + 1}</h6>
        <button style={{width:"15%"}} onClick={remove} className="btn">
          <DeleteOutlineOutlined color='error' />
        </button>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Controller
          
            name={`criteria.${index}.field`}
            control={control}
               render={({ field }) => {
                                  const options = criteriaAvailableFields.map(option => ({
                                    label: option,
                                    id: option,
                                  }));
            
                                  return (
                                    <Autocomplete
                                      size="small"
                                      options={options}
                                      value={options.find(opt => opt.id == field.value) || null}
            
                                      onChange={(e, item) => {
                                        field.onChange(item ? item.id : null);
                                      }}
            
                                      renderOption={(props, option) => (
                                        <li {...props} className="p-2">
                                          {option.label}
                                        </li>
                                      )}
            
                                      renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Field" />
                                      )}
                                    />
                                  );
                                }}
            // render={({ field }) => (
            //   <FormControl className="w-100">
            //     <Select
            //      MenuProps={{
            //                         PaperProps: {
            //                           style: {
            //                             maxHeight: 200,
            //                             overflowY: "scroll",
            //                             // width: "auto",
            //                           },
            //                         },
            //                       }}
            //       value={field.value || ""}
            //       onChange={(e) => field.onChange(e.target.value)}
            //       displayEmpty
            //     >
            //       {criteriaAvailableFields.map((option) => (
            //   <MenuItem
            //                                         key={option}
            //                                         value={option}
            //                                         className="custom-menu-item "
                                                    
            //                                     >
            //                                         <div className='label-size m-0'>               {option}
            //                                         </div>
            //                                     </MenuItem>
            //       ))}
            //     </Select>
            //   </FormControl>
            // )}
          />
        </div>

        <div className="col-md-6">
          <Controller
            name={`criteria.${index}.operator`}
            control={control}
                render={({ field }) => {
                                  const options = criteriaOperators.map(option => ({
                                    label: option.label,
                                    id: option.value,
                                  }));
            
                                  return (
                                    <Autocomplete
                                      size="small"
                                      options={options}
                                      value={options.find(opt => opt.id == field.value) || null}
            
                                      onChange={(e, item) => {
                                        field.onChange(item ? item.id : null);
                                      }}
            
                                      renderOption={(props, option) => (
                                        <li {...props} className="p-2">
                                          {option.label}
                                        </li>
                                      )}
            
                                      renderInput={(params) => (
                                        <TextField {...params} placeholder="Equals" />
                                      )}
                                    />
                                  );
                                }}
            // render={({ field }) => (
            //   <FormControl className="w-100">
            //     <Select
            //      MenuProps={{
            //                         PaperProps: {
            //                           style: {
            //                             maxHeight: 200,
            //                             overflowY: "scroll",
            //                             // width: "auto",
            //                           },
            //                         },
            //                       }}
            //       value={field.value || ""}
            //       onChange={(e) => field.onChange(e.target.value)}
            //       displayEmpty
            //     >
            //       {criteriaOperators.map((option) => (
            //        <MenuItem
            //                                         key={option.value}
            //                                         value={option.value}
            //                                         className="custom-menu-item "
                                                    
            //                                     >
            //                                         <div className='label-size m-0'>               {option.label}
            //                                         </div>
            //                                     </MenuItem>
            //       ))}
            //     </Select>
            //   </FormControl>
            // )}
          />
        </div>
      </div>

      {valueFields.map((val, valIndex) => (
        <div key={val.id} className="d-flex mt-2 align-items-center">
          <TextField
          size='small'
            className="w-100 me-2"
            {...register(`criteria.${index}.value.${valIndex}`)}
            placeholder="Add value"
          />
          {valueFields.length > 1 && (
            <button
              type="btn"
              onClick={() => removeValue(valIndex)}
              className="btn"
            >
              <DeleteOutlineOutlined color='error'/>
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        className="btn"
        onClick={() => appendValue("")}
      >
        + Add value
      </button>
    </div>
  );
};

const TargetingRules = () => {
     
       const { user } = useSelector((state) => state.auth);
      
      const token = user?.token;

    const [ruleShow , setRuleShow] = useState(false)
    const [rulePreviewShow , setRulePreviewShow] = useState(false)
    const [ targetRules, setTargetRules] = useState([])
    const [ targetRulePreview, setTargetRulePreview] = useState({})
    const [ targetPreviewMatchedUsers, setTargetPreviewMatchedUsers] = useState([])

    const [ criteriaOperators, setCriteriaOperators] = useState([])
    const [criteriaAvailableFields , setCriteriaAvailableFields] = useState({})
    const [isActive , setIsActive] = useState(0)
    const [deleteRules , setDeleteRules] = useState(false)
    const [ruleId , setRuleId] = useState(null)
    const [isEdit , setIsEdit] = useState(false)
    const [filteredRules, setFilteredRules] = useState([]);      
    const [statusFilters, setStatusFilters] = useState([]); 
    const [searchText, setSearchText] = useState("");

        const columns = [
        {
            field: "name",
            headerName: "Name",
            flex: 0.6,
            minWidth: 80,
            renderCell: (params) => {
                return (
                    <p className="m-0">{params.row.name}</p>
                )
            }
        },
        {
            field: "description",
            headerName: "Description",
            flex: 0.8,
            minWidth: 100,
                renderCell: (params) => {
                return (
                    <p className="m-0 text-center">{params.row?.description}</p>
                )
            }
        },
        {
            field: "criteria",
            headerName: "Criteria",
            flex: 1,
            minWidth: 200,
         renderCell: (params) => {
           
                    
                return (
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        {params.row.criteria.map((criteria)=>
                        <>
                        <p>{criteria?.field}</p>
                        <p>{criteria?.operator}</p>
                        <p className=''>{`${criteria?.value} `}</p>

                        </>
                        )}
                        
                    </div>
                )
            }
        },

    
        {
            field: "is_active",
            headerName: "Status",
            flex: 0.6,
            minWidth: 80,
             renderCell: (params) => {
                return(
                    <div className='d-flex gap-2 align-items-center justify-content-center'>
                        {params.row.is_active?
                 <>
                        <CircleIcon sx={{color:"#8CB369", fontSize:10}}/>
                        <p className='m-0'>Active</p>
                 </>
                        
                        : 
                        <>
                        <CircleIcon sx={{color:"#FC6C4F", fontSize:10}}/>
                        <p className='m-0'>Inactive</p>

                        </>
                        }
                    </div>
                )
             }
        },
        {
            field: "used_in",
            headerName: "Used In",
            flex: 0.6,
            minWidth: 80,
            renderCell: (params) => {
                return(
                    <div 
                     style={{
          
      whiteSpace: 'normal',
      lineHeight: 1.4,
          
        }}
                    className="d-flex flex-column justify-content-center">
                        <span>{params.row?.campaigns_count} campaigns</span>
                        <span>{params.row?.user_groups_count} groups</span>
                    </div>
                )
            }
        },

        {
            field: "Actions",
            headerName: "Actions",
            flex: .6,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <div className='d-flex justify-content-evenly align-items-center h-100 w-100'>
                        <IconButton
                            onClick={(e) => handleRulePreviewShow(e, params.row)}
                            sx={{color:"black"}}
                            aria-label="Preview"
                            size="small"
                            style={{ width: "33%" }}

                        >
                            <EyeOutlined />
                        </IconButton>
                        <IconButton
                            onClick={(e) => handleUpdateRuleShow(e, params.row)}
                            color="default"
                            aria-label="edit"
                            size="small"
                            style={{ width: "33%" }}
                        >
                            <Edit />
                        </IconButton>
                        <IconButton
                            onClick={(e) => handleDeleteRuleShow(e, params.row?.id)}
                            color="error"
                            aria-label="delete"
                            size="small"
                            style={{ width: "33%" }}
                        >
                            <DeleteOutlineOutlined />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

const PreviewRulesColumns = [
        {
            field: "id",
            headerName: "ID",
            flex: 0.9,
            minWidth: 100,
         
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 0.8,
            minWidth: 120,
            
        },
        {
            field: "last_login_at",
            headerName: "Last Login",
            flex: 0.8,
            minWidth: 120,
               renderCell: (params) => {
                return (
                    <p className="m-0">{new Date(params.row?.last_login_at).toLocaleDateString()}</p>
                )
            }
        },
     
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    
     const [anchorEl, setAnchorEl] = useState(null);
    
    
      const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
      };
    
      const handleClose = () => {
        setAnchorEl(null);
      };
    
      const open = Boolean(anchorEl);
  const {
          register,
          handleSubmit,
          setValue,
          control,
          reset,
          formState: { errors },
      } = useForm({
        defaultValues: {
            name:"",
            description:"",
            is_active: 0,
             criteria: [{
                operator:"",
                field:"",
                value:[""]
            }],
        },
    })
        const { fields: criteriaFields, append, remove } = useFieldArray({
            control,
            name: "criteria",
        });
    
      const handleRuleShow = ()=>{
        setRuleShow(true)
      }
      const handleRuleClose = ()=>{
        setRuleShow(false)
        setIsEdit(false)
        reset({
            name:"",
            description:"",
            is_active: 0,
             criteria: [{
                operator:"",
                field:"",
                value:[""]
            }],
        })
      }
        const handleUpdateRuleShow = (e, rule)=>{
        console.log(rule);
        
        e.stopPropagation()
        setRuleId(rule.id)
        setRuleShow(true)
        setIsEdit(true)
 
    const formattedCriteria = rule.criteria?.map(c => ({
  operator: c.operator || "",
  field: c.field || "",
  value: Array.isArray(c.value) ? c.value : [c.value],
})) || [];

reset({
  name: rule.name || "",
  description: rule.description || "",
  is_active: rule.is_active || 0,
  criteria: formattedCriteria 
});

    }
      const handleRulePreviewShow = async (e,rule)=>{
        e.stopPropagation()
        setRulePreviewShow(true)
        setTargetRulePreview(rule)
                try {
            const response = await axios.get(`${newHost}portal/targeting-rules/${rule.id}/preview`,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            setTargetPreviewMatchedUsers(response.data.data?.matched_users)
        } catch (error) {
            console.log(error);
            
        }
      }
      const handleRulePreviewClose = ()=>{
        setRulePreviewShow(false)
      

      }
       const handleDeleteRuleShow = (e,id)=>{
        setDeleteRules(true)
        setRuleId(id)
        e.stopPropagation()
    }
    const handleDeleteRuleClose = ()=>{
        setDeleteRules(false)
    }
    const handleActiveChange = (checked)=>{
        console.log(checked);
        if(checked){
            setIsActive(1)
        }
        
    }
  const handleStatusToggle = (status) => {
    
  setStatusFilters((prev) =>
    
    prev.includes(status)
      ? prev.filter((s) => s !== status)
      : [...prev, status]
  );
};

    const getAllTargetRules = async ()=>{
        try {
            const response = await axios.get(`${newHost}portal/targeting-rules`,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            setTargetRules(response.data.data?.targeting_rules?.data)
             setFilteredRules(response.data.data.targeting_rules?.data); 
        } catch (error) {
            console.log(error);
            
        }
    }
    const getTargetRulePreview = async ()=>{

    }
    const getCriteriaOperators = async ()=>{
        try {
            const response = await axios.get(`${newHost}portal/comparison-operators`,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            setCriteriaOperators(response.data.data?.operators)
        } catch (error) {
            console.log(error);
            
        }
    }
    const getCriteriaFields = async ()=>{
        try {
            const response = await axios.get(`${newHost}portal/targeting-rules/available-fields`,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            setCriteriaAvailableFields(response.data.data?.available_fields)
        } catch (error) {
            console.log(error);
            
        }
    }
  const submitRule = async (data)=>{
        console.log(data);
        if(isEdit){
               try {
              const response = await axios.post(`${newHost}portal/targeting-rules/${ruleId}`,
              {  ...data,
                _method : "PATCH"
              }
              
              ,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            toast.success(response.data.message)
            getAllTargetRules()
            setRuleShow(false)
                reset({
            name:"",
            description:"",
            is_active: 0,
             criteria: [{
                operator:"",
                field:"",
                value:[""]
            }],
        })
           setIsEdit(false)
        } catch (error) {
            toast.error(error.response.data.message)
        }
        } else{
      try {
              const response = await axios.post(`${newHost}portal/targeting-rules`,
                data
              
              ,{
                headers:{Authorization:`Bearer ${token}`}
            })
            console.log(response);
            toast.success(response.data.message)
            getAllTargetRules()
            setRuleShow(false)
                reset({
            name:"",
            description:"",
            is_active: 0,
             criteria: [{
                operator:"",
                field:"",
                value:[""]
            }],
        })
        } catch (error) {
            toast.error(error.response.data.message)
        }
        }
  
      }
    const handleDeleteRule = async ()=>{
        try {
            const response = await  axios.delete(`${newHost}portal/targeting-rules/${ruleId}`,{
               headers:{Authorization:`Bearer ${token}`}

            })
         toast.success(response.data?.data?.message)
        setDeleteRules(false)
        getAllTargetRules()

        } catch (error) {
            console.log(error);
            toast.error(error.response.message)
        }

    }
    useEffect(() => {
          let filtered = [...targetRules];

  if (statusFilters.length > 0) {
    filtered = filtered.filter(rule => {
      return (
        (statusFilters.includes("Active") && rule.is_active === true) ||
        (statusFilters.includes("Inactive") && rule.is_active === false)
      );
    });

} 
 if (searchText.trim() !== "") {
    filtered = filtered.filter(rule =>
      rule.name?.toLowerCase().includes(searchText.toLowerCase())
    );
  }
    setFilteredRules(filtered); 

}, [statusFilters, targetRules, searchText]);

     useEffect(() => {
       getAllTargetRules()
       getTargetRulePreview()
     getCriteriaOperators()
     getCriteriaFields()
     }, [])
     
  return (
    <>
      <DeleteModal
         showDelete={deleteRules} 
         handleDeleteClose={handleDeleteRuleClose}
         textMessage={" Are you sure you want to delete this Rule?"}
         deleteFunction={handleDeleteRule}
        />
      <Modal show={ruleShow} onHide={handleRuleClose}>
                <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
                    <Modal.Title style={{fontSize:25}}>
                        {isEdit?"Update Target Rule" : "Create New Targeting Rule"}
                        
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(submitRule)}>
                        <div className="my-2">
                            <label htmlFor="">Name</label>
                            <TextField 
                            size='small'
                        style={{outlineColor:"black",}}
                            className='w-100 ' type='text' placeholder='Add targeting rule name' 
                            {...register("name")}
                            />
                        </div>
                        <div className="my-2">
                            <label htmlFor="">Description</label>
                            <textarea style={{padding:10, borderRadius:15,border:"solid 2px #D8D8D8",}}  rows={3} className='w-100'  type='text' placeholder='Enter Rule Description' 
                              {...register("description")}

                            />
                        </div>
                        <div className="my-2">
                          <label htmlFor="">Targeting Criteria</label>
         
   {criteriaFields.map((item, index) => (
  <CriteriaBlock
    key={item.id}
    index={index}
    control={control}
    register={register}
    remove={() => remove(index)}
    criteriaAvailableFields={criteriaAvailableFields}
    criteriaOperators={criteriaOperators}
    isEdit={isEdit}
  />
))}



<div className="d-flex justify-content-end my-2">
  <button
    type="button"
    onClick={() => append({ operator: "", field: "", value: [""] })}
    className="border-0 bg-transparent"
  >
    <Add />
    Add Criterion
  </button>
</div>

                                                        </div>

                        <div className="d-flex align-items-start gap-2 mx-2">
                    
    

<Controller
  name="is_active"
  control={control}
  defaultValue={0} 
  render={({ field: { onChange, value, ref } }) => (
    <div className="d-flex align-items-start gap-2 mx-2">
      <input
        type="checkbox"
        className="my-1"
        ref={ref}
        checked={!!value} 
        onChange={(e) => onChange(e.target.checked ? 1 : 0)} 
      />
      <div>
        <p className="m-0 label-size">Active</p>
        <p className="status-text-rule m-0">Enable this targeting rule</p>
      </div>
    </div>
  )}
/>

                        </div>
                        <div className="d-flex gap-4 justify-content-center align-items-center  py-4">

                            <button type='reset' className='px-5 py-2 btn btn-light' onClick={handleRuleClose}>
                                Cancel
                            </button>
                            <button className='px-5 py-2 btn btn-dark' >
                                Save
                            </button>
                        </div>
                    </form>

                </Modal.Body>

            </Modal>
      <Modal show={rulePreviewShow} onHide={handleRulePreviewClose}>
                <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
                    <Modal.Title className='font-size-responsive-title-modal' style={{fontSize:22}}>
                        Rule Preview - {targetRulePreview.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="border rounded-2 my-3 p-2">
                    <p className="label-size fw-semibold m-0">Targeting Criteria</p>
                
                    {targetRulePreview?.criteria?.map((criteria)=>
                    <p className="label-size fw-light m-0 font-size-responsive">{`${criteria.field} ${criteria.operator} ${criteria.value}`}</p>

                    )}

                </div>
                <div className='d-flex gap-2 align-items-center '>
                    <h6 className='m-0 fw-semibold label-size'>Matched Users</h6>
                    <span className='bg-dark rounded-4 text-white px-2 label-size'>{targetPreviewMatchedUsers.length}</span>
                </div>
                <div className="my-2">
                      {targetPreviewMatchedUsers.length > 0 ?
                      <div className="data-grid-small">
                                           <Paper sx={{ height:"auto", width: "100%" }}>
                                                    <DataGrid
                                                    autoHeight
                                                      rows={targetPreviewMatchedUsers}
                                                      columns={PreviewRulesColumns}
                                                      initialState={{ pagination: { paginationModel } }}
                                                      pageSizeOptions={[5, 10]}
                                                      sx={{ border: 0 }}
                                                    />
                                                  </Paper>
                      </div>
                             :    <div className="flex flex-column text-center">
                          
                        <img src={noData} alt="no-data" />
                        <p style={{color:"#535353"}} className=''>No available Matched Users</p>
                    </div>
                            }
                     
                   
                </div>

                </Modal.Body>

            </Modal>

         <div className='min-vh-100 m-4'>
                    <div className="d-flex justify-content-between align-items-center header-responsive">
                        <h5 className='fw-semibold m-0'>Targeting Rules</h5>
                        <button onClick={handleRuleShow} className='btn btn-light' > <Add /> Add New Rule </button>
                    </div>
                      <div className='row  align-items-center justify-content-end '>
                              
                    
                              <div className='col-md-6 col-sm-12 justify-content-end d-flex gap-2 my-3 input-group-responsive'>
                                <div className="w-100 d-flex align-items-center justify-content-end position-relative ">
                                  <input className='w-100 py-2 ps-3 pe-5  rounded-2 search-point' type="text" placeholder="Search targeting rules" 
                                   value={searchText}
                                   onChange={(e) => setSearchText(e.target.value)}
                                  />
                                  <Search sx={{ color: " #535353", position: "absolute" }} />
                    
                                </div>
                                <button onClick={handleClick} className='btn btn-light'>        <Tune /></button>
                    
                    
                                <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
                                  <ClickAwayListener onClickAway={handleClose}>
                               
                                    <Paper sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2, minWidth: 200 }}>
  <FormGroup>
    {["Active", "Inactive"].map((item) => (
      <FormControlLabel
        key={item}
        control={
          <Checkbox
            icon={<CircleOutlinedIcon sx={{fontSize:15}} />}
                                       checkedIcon={<CircleIcon sx={{color:"black",fontSize:15}}/>}
            checked={statusFilters.includes(item)}
            onChange={() => handleStatusToggle(item)}
          />
        }
        label={item}
      />
    ))}
  </FormGroup>
</Paper>

                                  </ClickAwayListener>
                                </Popper>
                              </div>
                    
                            </div>
                              <div className='data-grid-small'>
                                                <Paper sx={{ height: "auto", width: "100%" }}>
                                                    <DataGrid
                                                        autoHeight
                                                        rows={filteredRules}
                                                        columns={columns}
                                                        initialState={{ pagination: { paginationModel } }}
                                                        pageSizeOptions={[5, 10]}
                                                        sx={{ border: 0 }}
                                                        checkboxSelection
                                                    />
                                                </Paper>
                                            </div>
                    </div>
    </>
  )
}

export default TargetingRules